import react, { useState, useEffect } from 'react';
import useEventSink from '../../hooks/useEventSink';
import logging from '@sstdev/lib_logging';
import { Text, styled, fromTheme } from 'lib_ui-primitives';
import PropTypes from 'prop-types';
import lodash from 'lodash';

const { get } = lodash;
const rc = react.createElement;

const StyledText = styled(Text)`
    ${({ theme, textWeight, textSize }) => fromTheme('fonts', textSize, textWeight)({ theme })}
`;

export default function ShortTextView(props) {
    const { namespace, relation, propertyName, textWeight, textSize } = props.hNode;
    const [, , request] = useEventSink();
    const [text, setText] = useState('');
    useEffect(() => {
        async function getText() {
            const data = await request({}, { verb: 'get', namespace, relation });
            if (data.result && data.result.length === 1) {
                let content = get(data.result[0], propertyName, '');
                if (Array.isArray(content)) {
                    content = content.join(', ');
                } else if (typeof content !== 'string') {
                    content = JSON.stringify(content);
                }
                setText(content);
            } else {
                logging.warn(`Unexpected results from get_${namespace}_${relation}`);
            }
        }
        getText();
    }, [request, namespace, relation, propertyName]);
    return rc(StyledText, { id: props.hNode.id, textWeight, textSize }, text);
}

ShortTextView.propTypes = {
    hNode: PropTypes.object
};
